export default __webpack_public_path__ + "images/4de541a084a6d740bdb5cef5ecd2dcec.svg";